module.exports = __webpack_public_path__ + "img/framework-agreement.2c021a5c.svg";